import React from 'react';
import PropTypes from 'prop-types';
import { getSizeGuide } from './categoryMap';
import * as Styled from './SizeGuide.styles';

var SizeGuide = function SizeGuide(_ref) {
  var categoryId = _ref.categoryId,
      dataTest = _ref['data-test'];
  var SizeGuideComponent = getSizeGuide(categoryId, dataTest);

  if (!SizeGuideComponent) {
    return /*#__PURE__*/React.createElement(Styled.NotFound, {
      "data-test": "not-found"
    }, "Oops, there isn\u2019t a size chart for this product right now. To carry on shopping just close this pop-up box.");
  }

  return /*#__PURE__*/React.createElement(Styled.Container, {
    "data-test": dataTest
  }, SizeGuideComponent);
};

SizeGuide.propTypes = {
  /**
   * The PIM ID of a category.
   */
  categoryId: PropTypes.string,

  /**
   * Optional data-test attribute on the Size Guide container.
   */
  'data-test': PropTypes.string
};
SizeGuide.defaultProps = {
  categoryId: null,
  'data-test': 'size-guide'
};
export default SizeGuide;